import { Component } from '@angular/core';
import { AppState } from 'src/app/App.state';
import {
  GestaoDDImportacaoItemResultadoDTO,
  GestaoDDImportacaoResultadoDTO,
} from 'src/app/base/domain/dto/gestao-dd-importacao-resultado.dto';
import { ContratoService } from 'src/app/base/services/contrato.service';
import { DialogService } from 'src/app/global/services/dialog.service';

@Component({
  selector: 'app-gestao-dd-main',
  templateUrl: './gestao-dd-main.component.html',
  styleUrls: ['./gestao-dd-main.component.css'],
})
export class GestaoDDMainComponent {
  arquivo: File;
  resultado: GestaoDDImportacaoResultadoDTO;

  constructor(
    private contratoService: ContratoService,
    private dialogService: DialogService,
    private appState: AppState,
  ) {}

  onArquivoSelecionado(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.arquivo = input.files && input.files.length ? input.files[0] : null;
    this.resultado = null;
  }

  importar(): void {
    if (!this.arquivo) {
      this.dialogService.feedbackInfo('Selecione um arquivo XML ou Excel para importar.');
      return;
    }

    this.appState.isLoading = true;
    this.contratoService.importarGestaoDD(this.arquivo).subscribe(
      (resultado: GestaoDDImportacaoResultadoDTO) => {
        this.appState.isLoading = false;
        this.resultado = resultado;
        this.dialogService.feedbackSuccess('Importação da Gestão DD finalizada.');
      },
      () => {
        this.appState.isLoading = false;
        this.dialogService.feedbackError('Ocorreu um erro ao importar o arquivo da Gestão DD.');
      },
    );
  }

  get itens(): GestaoDDImportacaoItemResultadoDTO[] {
    return this.resultado?.itens || [];
  }
}
